import { render, staticRenderFns } from "./TabCoupon.vue?vue&type=template&id=49f8d2a0&"
import script from "./TabCoupon.vue?vue&type=script&lang=js&"
export * from "./TabCoupon.vue?vue&type=script&lang=js&"
import style0 from "./TabCoupon.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports